import './public-application-loading-placeholder.css';

export default function PublicApplicationLoadingPlaceholder({
  landing = false,
}: {
  landing?: boolean;
}) {
  return (
    <div
      aria-busy="true"
      aria-label="Loading website"
      className={`public-application-loading-placeholder${landing ? ' public-application-loading-placeholder--landing' : ''}`}
      role="status"
    >
      <header className="public-application-loading-placeholder__header">
        <span className="public-application-loading-placeholder__wordmark">
          Forum <span>&amp;</span> Lex
        </span>
      </header>
    </div>
  );
}
